import { render, staticRenderFns } from "./FlightDetails.vue?vue&type=template&id=99f0bcbc&scoped=true"
import script from "./FlightDetails.vue?vue&type=script&lang=js"
export * from "./FlightDetails.vue?vue&type=script&lang=js"
import style0 from "./FlightDetails.vue?vue&type=style&index=0&id=99f0bcbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f0bcbc",
  null
  
)

export default component.exports